export class LoanExceptionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getById({ id, signal }) {
    return this.#http.get(`/loanExceptions/${id}`, { signal });
  }

  async getForLoan({ loanId, signal }) {
    return this.#http.get(`/loans/${loanId}/loanExceptions`, { signal });
  }

  async search({ filter, signal }) {
    return this.#http.post('/loanExceptions/search', filter, { signal });
  }

  async create({ payload, signal }) {
    return this.#http.post('/loanExceptions', payload, { signal });
  }

  async update({ id, payload, signal }) {
    return this.#http.put(`/loanExceptions/${id}`, payload, { signal });
  }

  async decide({ id, payload, signal }) {
    return this.#http.post(`/loanExceptions/${id}/decision`, payload, { signal });
  }

  async withdraw({ id, payload, signal }) {
    return this.#http.post(`/loanExceptions/${id}/withdraw`, payload, { signal });
  }
}
